export const relativeUrl = (url: string): string => {
    if (typeof url !== 'string') return '';

    try {
        const parsedUrl = new URL(url);
        url = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch {}

    return url
}

export const mapApiFieldErrors = (
  errors?: Record<string, { message?: string; label?: string }>
): Record<string, string> => {
  if (!errors) return {}
  return Object.fromEntries(
    Object.entries(errors)
      .map(([key, value]) => [key, value?.message])
      .filter(([, message]) => typeof message === 'string' && message.length > 0)
  ) as Record<string, string>
}

// Pulls the HTTP status and the full parsed response body out of a thrown $fetch
// error, so callers can console-log the complete backend payload (e.g. the per-field
// `errors` a checkout 400 returns) instead of an opaque FetchError.
export const apiErrorResponse = (payload: unknown): { status?: number; body: unknown } => {
  if (!payload || typeof payload !== 'object') return { body: payload }
  const obj = payload as Record<string, any>
  const response = obj.response && typeof obj.response === 'object' ? obj.response : undefined
  return {
    status: obj.statusCode ?? obj.status ?? response?.status,
    body: obj.data ?? response?._data ?? obj,
  }
}

export const extractApiFieldErrors = (payload: unknown): Record<string, string> => {
  if (!payload || typeof payload !== 'object') return {}
  const obj = payload as Record<string, unknown>

  const fromData =
    obj.data && typeof obj.data === 'object'
      ? (obj.data as Record<string, unknown>).errors
      : undefined

  const fromResponse =
    obj.response && typeof obj.response === 'object'
      ? ((obj.response as Record<string, unknown>)._data as Record<string, unknown> | undefined)?.errors
      : undefined

  const candidates = [obj.errors, fromData, fromResponse]
  for (const candidate of candidates) {
    if (candidate && typeof candidate === 'object') {
      return mapApiFieldErrors(candidate as Record<string, { message?: string; label?: string }>)
    }
  }

  return {}
}
